var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactPaginate from "react-paginate";
import "./pagination.scss";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
var defaultElementPerPage = 5;
var defaultTotalResult = 40;
/** <b>Composant de Pagination qui permet à l'utilisateur de sélectionner une page spécifique à partir d'une plage de pages.</b>  */
export var Pagination = function (_a) {
    var sizeClass = _a.sizeClass, className = _a.className, currentPage = _a.currentPage, _b = _a.elementPerPage, elementPerPage = _b === void 0 ? defaultElementPerPage : _b, onChangePagination = _a.onChangePagination, _c = _a.totalResult, totalResult = _c === void 0 ? defaultTotalResult : _c, _d = _a.paginationVisible, paginationVisible = _d === void 0 ? true : _d;
    var module = useParams().module;
    var t = useTranslation(["Common"]).t;
    var pageCount = Math.ceil(totalResult / elementPerPage);
    var _e = useState(false), isFirstPage = _e[0], setFirstPage = _e[1];
    var goToFirstPage = function () {
        if (!onChangePagination) {
            return;
        }
        onChangePagination({ selected: 0 });
        setFirstPage(true);
    };
    var goToLastPage = function () {
        if (!onChangePagination) {
            return;
        }
        onChangePagination({ selected: pageCount - 1 });
    };
    return (_jsx(_Fragment, { children: pageCount > 1 && paginationVisible ? (_jsxs("div", __assign({ className: "flex flex-row items-center mr-[0.5rem]" }, { children: [_jsx("button", __assign({ onClick: goToFirstPage, className: "".concat(sizeClass, " item text-[#8197ab] dark:text-black pagination-page ").concat(
                    // bouton firstPage
                    currentPage === 0
                        ? "pointer-events-none text-[rgb(var(--color-gray-300))]"
                        : "", "\n            }") }, { children: _jsx(FontAwesomeIcon, { icon: faAngleDoubleLeft, className: "" }) })), _jsx(ReactPaginate, { previousLabel: _jsx(FontAwesomeIcon, { className: "flex items-center", icon: faAngleLeft }), nextLabel: _jsx(FontAwesomeIcon, { className: "flex items-center", icon: faAngleRight }), pageCount: pageCount, forcePage: currentPage, onPageChange: function (event) {
                        if (onChangePagination) {
                            onChangePagination(event);
                        }
                    }, previousLinkClassName: "pagination__link", nextLinkClassName: "pagination__link", activeClassName: "".concat(sizeClass, " item active "), breakClassName: "item break-me ", breakLabel: "...", containerClassName: "pagination", disabledClassName: "disabled-page", marginPagesDisplayed: 1, nextClassName: "".concat(sizeClass, " item defaultSize next"), pageClassName: "".concat(sizeClass, " item defaultSize pagination-page "), pageRangeDisplayed: 2, previousClassName: "".concat(sizeClass, " item defaultSize previous") }), _jsxs("span", __assign({ className: "item ".concat(sizeClass, " flex items-center text-[#8197ab] dark:text-black mx-3 pt-1") }, { children: ["\u00A0", t("app.LBL_SUR", { ns: "Common" }), "\u00A0", pageCount] })), _jsx("button", __assign({ onClick: goToLastPage, className: "".concat(sizeClass, " flex items-center item text-[#8197ab] pagination-page dark:text-black ").concat(currentPage === pageCount - 1
                        ? "pointer-events-none text-[rgb(var(--color-gray-300))]"
                        : "", "\n            }") }, { children: _jsx(FontAwesomeIcon, { icon: faAngleDoubleRight, className: "" }) }))] }))) : (_jsx(_Fragment, {})) }));
};
